export interface SystemNotification {
  id: string;
  type: 'invite' | 'broadcast' | 'security' | 'agent' | 'system';
  title: string;
  message: string;
  timestamp: number;
  read: boolean;
}

export class NotificationStore {
  private notifications: SystemNotification[] = [];

  addNotification(n: Omit<SystemNotification, 'id' | 'timestamp' | 'read'>): SystemNotification {
    const full: SystemNotification = {
      ...n,
      id: `notif-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
      timestamp: Date.now(),
      read: false,
    };
    this.notifications.unshift(full);
    return full;
  }

  getNotifications(): SystemNotification[] {
    return [...this.notifications];
  }

  getUnreadCount(): number {
    return this.notifications.filter((n) => !n.read).length;
  }

  markAllAsRead(): void {
    this.notifications.forEach((n) => (n.read = true));
  }
}

export const globalNotificationStore = new NotificationStore();
